<template>

    <!-- CLUSTER -->
    <div v-if="viewType=='cluster'" :class="[page.status ? page.status.name : '', type != null ? type : '', 'columns catalogPageRow status marginTop']">

        <div class="sectionHeading">{{ page.name }}</div>

        <!-- col pageElements LEFT -->
        <div class="column pageElementsLeftBox">
          <div class="page-sectionName">{{ page.name }}</div>
        </div>

        <!-- col DOUBLE PAGE Preview -->
        <div class="column is-2 pagesContainerBox">

            <div class="rectangle-box">
                <div class="rectangle-content">

                    <div class="columns">

                        <template v-if="type != 'bookmark'">

                            <div class="column is-6">

                                <div v-if="type=='back'" class="coverBox lazy-img-fadein" @click="goToPage(page.id, type)" v-lazy:background-image="getImage(page.preview)"></div>

                            </div>

                            <div class="column is-6">

                                <div v-if="type=='front'" class="coverBox lazy-img-fadein" @click="goToPage(page.id, type)" v-lazy:background-image="getImage(page.preview)"></div>

                            </div>

                        </template>


                        <template v-else>

                            <div class="column is-6">

                            </div>

                            <div class="column is-3">

                                <div class="coverBox lazy-img-fadein" @click="goToPage(page.id, type)" v-lazy:background-image="getImage(page.preview)"></div>

                            </div>

                            <div class="column"></div>

                        </template>


                    </div>

                    <!-- <div class="coverBox lazy-img-fadein" @click="goToPage(page.id, type)" v-lazy:background-image="getImage(page.preview)"></div> -->

                </div>
            </div>

        </div>

        <!-- col pageElements RIGHT -->
        <div class="column pageElementsRightBox">

        </div>

        <!-- col OPTIONS -->
        <div class="column is-narrow options">

        </div>

    </div>


    <!-- DETAILED -->
    <div v-else-if="viewType='detail'">



    </div>


</template>



<script>

export default {

    name: 'catalogPageSpecial',

    data() {

		return {

		}
	},

    components: {

    },

    props: {

        page: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        viewType: {
            type: String,
            default: null
        }

    },


    methods: {

        goToPage(pageId, type) {

            // redirect to the detail site
            // this.$router.push({ path: '/katalog/seite-' + pageId, query: { type: this.type } });
            this.$router.push({ name: 'catalogPageSpecial', params: { 'type': type, 'pageID': pageId } });

        },

        getImage(preview) {

            if(preview == null) {
                return '';
            }

            if(this.type != 'bookmark') {

                return this.$config.assets + preview.path + '/' + preview.filename + '.png';

            } else {

                return this.$config.assets + preview.path + '/' + preview.filename + '-0.png';

            }

		},

    }

}

</script>


<style scoped>

    .rectangle-box {
        position: relative;
        width: 100%;
        max-width: 1300px;
        padding: 0;
        margin: 0 auto;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: 98%;
    }
    .front .rectangle-box {
        background: transparent url('../../assets/img/bg-pages-front.jpg') no-repeat 45% 12%;
        background-size: 98%;
    }
    .back .rectangle-box {
        background: transparent url('../../assets/img/bg-pages-u4.jpg') no-repeat 45% 12%;
        background-size: 98%;
    }
    .bookmark .rectangle-box {
        background: transparent url('../../assets/img/bg-pages-bookmark.jpg') no-repeat 45% 12%;
        background-size: 98%;
    }

    .coverBox {
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: contain;
        cursor: pointer;
    }
    .coverBox[lazy=loading]  {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: 40% !important;
	}

    .columns.front .rectangle-content {
        top: 0;
        bottom: 0;
        left: 6%;
        right: 3%;
    }
    .columns.back .rectangle-content {
        top: 0;
        bottom: 0;
        left: 2%;
        right: 6%;
    }

    .columns.bookmark .column.is-3 {
        width: 21.7%;
    }
    .columns.bookmark .column.is-3 .coverBox {
        height: 100%;
        padding: 0;
    }

</style>
